export default __webpack_public_path__ + "245002768d63b1c4d09760dd82adc635.svg";